import React, { useState } from 'react';
import { useField } from 'formik';
import moment from 'moment';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import en from 'date-fns/locale/en-US';
import sv from 'date-fns/locale/sv';
import fi from 'date-fns/locale/fi';
import './datePicker.scss';

var DatePicker = function DatePicker(_a) {
  var name = _a.name,
      label = _a.label,
      required = _a.required,
      disabled = _a.disabled,
      className = _a.className,
      labelClass = _a.labelClass,
      dateFormat = _a.dateFormat,
      datePickerClass = _a.datePickerClass,
      locale = _a.locale,
      _onChange = _a.onChange,
      minDate = _a.minDate,
      maxDate = _a.maxDate,
      errorClass = _a.errorClass;

  var _b = useField(name),
      field = _b[0],
      meta = _b[1],
      form = _b[2];

  registerLocale('fi', fi);
  registerLocale('sv', sv);
  registerLocale('en', en);

  var _c = useState(false),
      calenderOpen = _c[0],
      setCalendarOpen = _c[1];

  var formatValue = function formatValue(val) {
    return typeof val === 'string' && val !== '' ? moment(val).toDate() : val;
  };

  var handleCalenderState = function handleCalenderState(open) {
    setCalendarOpen(open);
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(name, "-wrapper"),
    className: "epidemic-design-date-picker-date-picker-wrapper ".concat(className)
  }, /*#__PURE__*/React.createElement("span", null, required && /*#__PURE__*/React.createElement("span", {
    className: 'epidemic-design-date-picker-asterisk',
    "aria-hidden": true
  }, "*"), /*#__PURE__*/React.createElement("label", {
    "data-testid": "".concat(name, "-label"),
    htmlFor: name,
    className: "epidemic-design-date-picker-label ".concat(required ? 'epidemic-design-date-picker-required' : '', " ").concat(labelClass)
  }, label)), /*#__PURE__*/React.createElement("div", {
    className: "epidemic-design-date-picker-date-wrapper"
  }, /*#__PURE__*/React.createElement(ReactDatePicker, {
    id: name,
    name: name,
    className: "epidemic-design-date-picker-date-picker-input ".concat(datePickerClass),
    locale: locale,
    selected: formatValue(field.value),
    dateFormat: dateFormat !== null && dateFormat !== void 0 ? dateFormat : 'dd.MM.yyyy',
    onChange: function onChange(val) {
      if (_onChange) _onChange(val);
      form.setValue(val);
    },
    onFocus: function onFocus() {
      return handleCalenderState(false);
    },
    onSelect: function onSelect() {
      return handleCalenderState(false);
    },
    open: calenderOpen,
    onBlur: function onBlur() {
      return handleCalenderState(false);
    },
    disabled: disabled,
    minDate: minDate,
    maxDate: maxDate,
    autoComplete: 'off',
    "data-testid": "".concat(name, "-input"),
    ariaDescribedBy: "".concat(name, "-error"),
    required: required
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(name, "-button"),
    role: "button",
    tabIndex: -1,
    onKeyDown: function onKeyDown() {
      return handleCalenderState(false);
    },
    onClick: function onClick() {
      return handleCalenderState(!calenderOpen);
    },
    className: "epidemic-design-date-picker-date-icon"
  }, /*#__PURE__*/React.createElement("img", {
    "data-testid": "".concat(name, "-icon"),
    alt: "calender",
    src: "data:image/svg+xml,%3Csvg width='35' height='35' viewBox='-5 3 30 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.14146 19.4286H5.35575V16.2143H2.14146V19.4286ZM6.07003 19.4286H9.64146V16.2143H6.07003V19.4286ZM2.14146 15.5H5.35575V11.9286H2.14146V15.5ZM6.07003 15.5H9.64146V11.9286H6.07003V15.5ZM2.14146 11.2143H5.35575V8H2.14146V11.2143ZM10.3557 19.4286H13.9272V16.2143H10.3557V19.4286ZM6.07003 11.2143H9.64146V8H6.07003V11.2143ZM14.6415 19.4286H17.8557V16.2143H14.6415V19.4286ZM10.3557 15.5H13.9272V11.9286H10.3557V15.5ZM6.42718 5.85714V2.64286C6.42718 2.54613 6.38997 2.46429 6.31557 2.39732C6.24861 2.32292 6.16676 2.28571 6.07003 2.28571H5.35575C5.25902 2.28571 5.17346 2.32292 5.09905 2.39732C5.03209 2.46429 4.99861 2.54613 4.99861 2.64286V5.85714C4.99861 5.95387 5.03209 6.03943 5.09905 6.11384C5.17346 6.1808 5.25902 6.21429 5.35575 6.21429H6.07003C6.16676 6.21429 6.24861 6.1808 6.31557 6.11384C6.38997 6.03943 6.42718 5.95387 6.42718 5.85714ZM14.6415 15.5H17.8557V11.9286H14.6415V15.5ZM10.3557 11.2143H13.9272V8H10.3557V11.2143ZM14.6415 11.2143H17.8557V8H14.6415V11.2143ZM14.9986 5.85714V2.64286C14.9986 2.54613 14.9614 2.46429 14.887 2.39732C14.82 2.32292 14.7382 2.28571 14.6415 2.28571H13.9272C13.8305 2.28571 13.7449 2.32292 13.6705 2.39732C13.6035 2.46429 13.57 2.54613 13.57 2.64286V5.85714C13.57 5.95387 13.6035 6.03943 13.6705 6.11384C13.7449 6.1808 13.8305 6.21429 13.9272 6.21429H14.6415C14.7382 6.21429 14.82 6.1808 14.887 6.11384C14.9614 6.03943 14.9986 5.95387 14.9986 5.85714ZM19.2843 5.14286V19.4286C19.2843 19.8155 19.143 20.1503 18.8602 20.433C18.5775 20.7158 18.2427 20.8571 17.8557 20.8571H2.14146C1.75456 20.8571 1.41974 20.7158 1.137 20.433C0.85426 20.1503 0.712891 19.8155 0.712891 19.4286V5.14286C0.712891 4.75595 0.85426 4.42113 1.137 4.13839C1.41974 3.85565 1.75456 3.71429 2.14146 3.71429H3.57003V2.64286C3.57003 2.15178 3.74488 1.7314 4.09459 1.3817C4.44429 1.03199 4.86468 0.857141 5.35575 0.857141H6.07003C6.56111 0.857141 6.98149 1.03199 7.33119 1.3817C7.6809 1.7314 7.85575 2.15178 7.85575 2.64286V3.71429H12.1415V2.64286C12.1415 2.15178 12.3163 1.7314 12.666 1.3817C13.0157 1.03199 13.4361 0.857141 13.9272 0.857141H14.6415C15.1325 0.857141 15.5529 1.03199 15.9026 1.3817C16.2523 1.7314 16.4272 2.15178 16.4272 2.64286V3.71429H17.8557C18.2427 3.71429 18.5775 3.85565 18.8602 4.13839C19.143 4.42113 19.2843 4.75595 19.2843 5.14286Z' fill='black'/%3E%3C/svg%3E"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "".concat(name, "-error"),
    "aria-live": "polite",
    className: errorClass
  }, meta.error));
};

DatePicker.defaultProps = {
  required: false,
  disabled: false,
  className: '',
  labelClass: '',
  dateFormat: 'd.M.yyyy',
  datePickerClass: '',
  locale: undefined,
  onChange: undefined,
  minDate: undefined,
  maxDate: undefined,
  errorClass: ''
};
export default DatePicker;